import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class DevelopRequest extends Component{
    render(){
        return(
            <div className="idea">
         <div></div>
         <div>
           <h1 className="text-capitalize">Have an app idea?</h1>
           <p> 
             We take design and development to a whole new level.
           </p> 
           <Link to="/catalogue/develop" className="butt">Talk to a developer</Link> 
         </div>
       </div>    
        )
    }
}

export default DevelopRequest;